module.exports = __webpack_public_path__ + "static/index/img/baikal-304.3aea2504.jpg";